export default function ArrowUpAndDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.59827 3.5L12.4954 7.25H4.70115L8.59827 3.5Z" fill="currentColor" />
      <path d="M8.59827 12.5L4.70115 8.75L12.4954 8.75L8.59827 12.5Z" fill="currentColor" />
    </svg>
  );
}
